<template>
  <div class="has-background-white is-border">
    <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
      <figure
        class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right"
        @mouseover="userAvatarHover = true"
        @mouseleave="userAvatarHover = false">
        <router-link
          data-tooltip="Editer la fiche"
          v-if="(isAdmin && !isAdminReferent) || (isManager && !isAdminReferent) || sourceMe"
          class="dot is-large has-background-light--darken3 has-text-white is-border is-border--white tooltip is-tooltip-right"
          :to="{name: 'UserEdit', params: {id: sourceUser.pk}}">
          <span class="icon"><i class="fas fa-pen"></i></span>
        </router-link>
        <div class="is-border is-border--circle is-clipped">
          <upload-file
            @upload="uploadUserAvatar($event)"
            :source-documents="[sourceUser.picture]"
            :is-avatar="true"
            :show-list="false"
            v-if="(isAdmin && !isAdminReferent) || sourceMe"
            class="is-border--circle is-clipped"
            :label-class="''"></upload-file>
          <div
            v-else
            class="has-text-white is-clipped is-relative"
            :class="{'has-background-light--darken2':!userAvatarHover, 'has-background-grey':userAvatarHover}"
            style="width: 126px; height: 126px; line-height: 126px;">
            <img
              v-if="sourceUser.picture"
              :src="sourceUser.picture|avatarBig">
            <i
              v-else
              class="is-absolutecenter fas fa-user-tie fa-6x"></i>
          </div>
        </div>
      </figure>
      <div
        v-if="sourceUser && sourceUser.last_name && sourceUser.first_name"
        class="title is-3 is-margin-top-xsmall is-marginless-bottom">
        <b id="userName">{{ sourceUser.last_name }} {{ sourceUser.first_name }}</b>
      </div>
      <div
        class="is-size-5 has-text-weight-light"
        v-if="sourceUser.profil">
        <span v-if="isAdminReferent">Référent</span>
        <span v-else>
          {{ sourceUser.profil | profilTypeLabel }}
          <span v-if="agence"> - {{ agence.name }}</span>
        </span>
        <span v-if="sourceUser.account && !(currentUser.account.pk === sourceUser.account.pk)">
          chez <b>
            <router-link
              v-if="(isAdmin || isManager)"
              :to="{name: 'CompanyVue', params: {id: sourceUser.account.pk}}">{{ sourceUser.account.name }}
            </router-link>
            <span v-else>{{ sourceUser.account.name }}</span>
          </b>
        </span>
      </div>
    </div>
    <div
      class="is-padding"
      v-if="(isAdmin || isManager) && !sourceMe">
      <div class="columns is-size-5 is-vcentered">
        <div class="is-size-5 column">
          <b>Dernière connexion :</b><br>
          {{ sourceUser.last_login_at|lastConnection }}
        </div>
      </div>
    </div>
    <div
      class="is-padding is-border-top"
      v-if="sourceUser.profil && sourceUser.profil === 'seller'">
      <div class="columns is-multiline">
        <div class="column is-12 columns is-column is-space-between">
          <div class="has-text-grey is-size-6">
            Manager
          </div>
          <div class="is-size-5">
            <router-link
              :to="{name: 'UserVue', params: {id: sourceUser.manager.pk || sourceUser.manager}}"
              v-if="sourceUser.manager && (isAdmin || isManager)">
              <span v-if="'last_name' in sourceUser.manager && 'first_name' in sourceUser.manager && sourceUser.manager.last_name && sourceUser.manager.first_name"><b>{{ sourceUser.manager.last_name }} {{ sourceUser.manager.first_name }}</b></span>
            </router-link>
            <span v-else-if="sourceUser.manager && 'last_name' in sourceUser.manager && 'first_name' in sourceUser.manager && sourceUser.manager.last_name && sourceUser.manager.first_name && sourceUser.profil === 'seller'"><b>{{ sourceUser.manager.last_name }} {{ sourceUser.manager.first_name }}</b></span>
            <span v-else>Aucun manager <span v-if="isAdmin && currentUser.account.pk === sourceUser.account.pk">: <a
              @click="openManagerSelectionModal"
              class="is-underline"> Spécifier manager</a></span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="is-padding is-border-top">
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless-bottom">
          <div class="columns is-gapless">
            <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
              <b>Mail :</b>
            </div>
            <div class="column is-size-6 is-break-word">
              <a
                :href="`mailto:${sourceUser.email}`"
                class="is-hover-underline">{{ sourceUser.email }}</a>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="columns is-gapless">
            <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
              <b>Téléphone :</b>
            </div>
            <div class="column is-size-6">
              <phone-number
                :phone="sourceUser.phone"
                :show-validation="true"></phone-number>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import UploadFile from '@/components/utils/form/UploadFile'

export default {
  name: 'UserLeftCol',
  components: { UploadFile },
  filters: {
    lastConnection (val) {
      if (val) {
        let d = moment(val)
        return d.format('DD/MM [à] HH:mm')
      } else {
        return 'AUCUNE'
      }
    }
  },
  mixins: [Quickview, DefaultValues],
  props: {
    sourceMe: {
      type: Boolean
    },
    sourceUser: {
      type: Object
    },
    agence: {
      type: Object
    }
  },
  data () {
    return {
      isActiveNotification: false,
      userAvatarHover: false
    }
  },
  computed: {
    ...mapState(['quickview']),
    ...mapGetters(['isAdmin', 'isManager', 'isFirstAdmin']),
    isAdminReferent () {
      return this.sourceUser.first_admin
    }
  },
  watch: {
    quickview ({ mode, params, results, close }) {
      if (results && mode === 'MANAGE_NOTIFICATION') {
        this.isActiveNotification = false
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$emit('updateUser', results.results)
      }
      if (close) {
        this.isActiveNotification = false
      }
      if (results && mode === 'USER_SELECTION' && this.sourceUser.profil === 'seller') {
        if (results.entities.length) {
          this.$emit('updateManager', results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez séléctionner un manager')
        }
      }
    }
  },
  methods: {
    /**
      * function in UserMixin.js
      */
    uploadUserAvatar (event) {
      this.$emit('uploadUserAvatar', event)
    },
    /**
      * prepare params for quickview
      * function in QuickviewMixin.js
      */
    openManagerSelectionModal () {
      let params = {
        facets: {
          USER: [
            ['profil:manager'],
            [`pk:-${this.sourceUser.pk}`]
          ]
        },
        mode: 'store'
      }
      this.openUserSelectionQuickview(params)
    }
  }
}
</script>
